import script from "./LocalLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./LocalLoader.vue?vue&type=script&setup=true&lang=js"

import "./LocalLoader.vue?vue&type=style&index=0&id=5750a660&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5750a660"]])

export default __exports__